function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtmlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1800pt",
    height: "1799.999925pt",
    viewBox: "0 0 1800 1799.999925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.408875%,30.198669%,14.898682%)",
      fillOpacity: 1
    },
    d: "M 385.597656 1470.625 L 271.128906 186.792969 L 1528.871094 186.792969 L 1414.28125 1470.386719 L 899.226562 1613.207031 Z M 385.597656 1470.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509888%,39.608765%,16.079712%)",
      fillOpacity: 1
    },
    d: "M 900 1504.085938 L 1316.214844 1388.726562 L 1414.105469 291.753906 L 900 291.753906 Z M 900 1504.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.158508%,92.158508%,92.158508%)",
      fillOpacity: 1
    },
    d: "M 900 767.9375 L 691.625 767.9375 L 677.242188 606.695312 L 900 606.695312 L 900 449.253906 L 505.179688 449.253906 L 508.925781 491.453125 L 547.617188 925.378906 L 900 925.378906 Z M 900 1176.84375 L 899.285156 1177.023438 L 723.957031 1129.652344 L 712.722656 1004.070312 L 554.6875 1004.070312 L 576.738281 1251.316406 L 899.285156 1340.824219 L 900 1340.644531 Z M 900 1176.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 899.464844 767.9375 L 899.464844 925.378906 L 1093.339844 925.378906 L 1075.03125 1129.59375 L 899.40625 1176.964844 L 899.40625 1340.761719 L 1222.191406 1251.316406 L 1224.570312 1224.6875 L 1261.597656 810.136719 L 1265.460938 767.878906 L 1223.023438 767.878906 Z M 899.464844 449.253906 L 899.464844 606.695312 L 1279.78125 606.695312 L 1282.933594 571.273438 L 1290.125 491.453125 L 1293.867188 449.195312 Z M 899.464844 449.253906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/HtmlLogo.fd0c3c4d5d531f620f72ed8a85f420f0.svg";
export { ForwardRef as ReactComponent };